import React from "react";
import { Link } from "react-router-dom";
import img1 from "./img/post-icon-1.svg";
import img2 from "./img/post-icon-2.svg";

const data = [
	{
		img: img1,
		title: "Polkapet world",
		link: "#",
		next_payment: "12/02/24",
		amount: "1,523 $PETS",
		remaining: "18,276 $PETS",
		last: "12/2/24",
	},
	{
		img: img2,
		title: "Dexpools",
		link: "#",
		next_payment: "12/02/23",
		amount: "105 $DXP",
		remaining: "2765 $PETS",
		last: "12/2/24",
	},
];

const PaymentSchedule = () => {
	return (
		<section className="payment-section pt-5 mt-2">
			<div className="schedule-table-wrapper">
				<h5 className="subtitle">Payment Schedule</h5>
				<div className="wrapper">
					{data && (
						<div className="table-responsive __table-responsive-md">
							<table className="table __schedule-data-table m-0">
								<thead>
									<tr>
										<th>Project Name</th>
										<th className="text-center">Next Payment</th>
										<th className="text-center">Amount</th>
										<th className="text-center">Remaining</th>
										<th className="text-center">Last</th>
									</tr>
								</thead>
								<tbody>
									{data.map(
										(
											{
												img,
												title,
												link,
												next_payment,
												amount,
												remaining,
												last,
											},
											i
										) => (
											<tr key={i}>
												<td data-label="Project Name">
													<Link
														to={link}
														className="table-project"
													>
														<img src={img} alt="" />
														<h6 className="name">{title}</h6>
													</Link>
												</td>
												<td
													className="text-center"
													data-label="Next Payment"
												>
													<div>{next_payment}</div>
												</td>
												<td
													className="text-center"
													data-label="Amount"
												>
													<div>{amount}</div>
												</td>
												<td
													className="text-center"
													data-label="Remaining"
												>
													<div>{remaining}</div>
												</td>
												<td
													className="text-center"
													data-label="Last"
												>
													<div>{last}</div>
												</td>
											</tr>
										)
									)}
								</tbody>
							</table>
						</div>
					)}
				</div>
			</div>
		</section>
	);
};

export default PaymentSchedule;
